/* eslint-disable import/prefer-default-export */
import { attachUploadFiles } from "components/jiffy/upload-files/upload-files";
import { redirectTo } from "common/utils/browser";

import "./upload-button.scss";

export function initUploadButton() {
  const $containers = document.querySelectorAll(".js-upload-files");

  return Array.from($containers).map(async $container => {
    const dropzone = await attachUploadFiles($container, $container);

    dropzone.on("sending", (file, xhr, formData) => {
      formData.append("generate_link", true);
      formData.append("catalog_number", "DTF001");
    });

    dropzone.on("success", (file, response) => {
      response.redirect_url && redirectTo(response.redirect_url);
    });
  });
}
